export enum PageForms {
  Contracts = '',
  ContractsBC = '/contracts-bc',
  Billing = '/billing-new',
  BillingCycles = '/billing-cycles',
  Customers = '/customers-new',
  CustomersLookup = '/customers-new',
  VarBilling = '/variable-billing',
  Products = '/products',
  Uplifts = '/uplifts-history',
  ClientDatabases = '/client-databases',
  PurchaseOrders = '/purchase-orders',
  ContractLines = '/contract-lines',
  Bundles = '/bundles',
  BillingByBillingCycles = '/billing-bc',
  ContractDetailsSalesOrdersByBc = '',
  ContractDetailsSalesOrders = ''
}

export enum SearchPageNames {
  Contracts = '',
  ContractsBC = 'Contracts',
  Billing = 'Billing',
  BillingCycles = 'Billing Cycles',
  Customers = 'Customers',
  CustomersLookup = 'CustomersLookUp',
  Products = 'Products',
  Uplifts = 'Uplifts',
  ClientDatabases = 'Client Databases',
  PurchaseOrders = 'Purchase Orders',
  ContractLines = 'Contract Lines',
  Bundles = 'Bundles',
  BillingByBillingCycles = 'Billing',
  ContractDetailsSalesOrdersByBc = 'ContractDetailsSalesOrdersByBc',
  ContractDetailsSalesOrders = 'ContractDetailsSalesOrders'
}
